import { useAtom } from '@reatom/npm-react'
import { AnimatePresence } from 'motion/react'

import { transactionDetailsDialogAtom } from '../../../atoms'

import { TransactionDetailsDialog } from './transaction-details-dialog'

type Props = {}

export const TransactionDetailsDialogController: React.FC<Props> = () => {
  const [activeTransaction, setActiveTransaction] = useAtom(
    transactionDetailsDialogAtom,
  )
  return (
    <>
      <AnimatePresence>
        {activeTransaction ? (
          <TransactionDetailsDialog
            tx={activeTransaction}
            open={true}
            onOpenChange={(open) => {
              if (!open) {
                setActiveTransaction(undefined)
              }
            }}
          />
        ) : undefined}
      </AnimatePresence>
    </>
  )
}
